module.exports = __webpack_public_path__ + "static/img/statistice-num.af407bf7.png";